import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { getPostAuthPath } from '@/lib/post-auth-redirect';

/** Sends authenticated users to dashboard (or onboarding if no property yet). */
export function usePostAuthRedirect(enabled = true) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled || loading || !user) return;

    let cancelled = false;
    void getPostAuthPath(user.id).then((path) => {
      if (!cancelled) navigate(path, { replace: true });
    });

    return () => {
      cancelled = true;
    };
  }, [enabled, user, loading, navigate]);
}
